export default {
  feature: 'Funktion',
  features: 'Funktionen',
  featuresOf: '{{type}}-Funktionen',
  'feature.list.title': 'Funktionsverwaltung',
  'feature.list.subtitle':
    'Verwalten Sie die Funktionen Ihrer Anwendung effektiv.',
  'feature.list.search.placeholder':
    'Funktionen nach Name oder Beschreibung suchen',
  'feature.info': 'Funktionsinformationen',
  'feature.form.title': 'Funktionstitel',
  'feature.form.description': 'Funktionsbeschreibung',
  'feature.form.assignments': 'Zuweisungen',
  'feature.form.slug': 'Slug',
  'feature.form.slug.helper':
    'Stabile Kennung, auf die Consumer-Apps im Code verweisen. Kleinbuchstaben, Ziffern, Unterstriche (max. 50). Kann nicht geändert werden, solange die Funktion aktiv ist.',
  'feature.form.slug.invalid':
    'Slug muss mit einem Kleinbuchstaben beginnen und darf nur Kleinbuchstaben, Ziffern und Unterstriche enthalten (max. 50 Zeichen).',
  'feature.info.helper':
    'Geben Sie einen klaren Titel, eine prägnante Beschreibung und einen passenden Typ zur Definition der Funktion an',
  'feature.msg.deactivateBlocked': 'Deaktivierung blockiert',
  'feature.msg.deactivateBlockedDescription':
    'Sie können diese Funktion nicht deaktivieren, da sie bereits für {{subscriptionName}} verwendet wird.',
  'feature.actions.navigateToSubscription': 'Zum Abonnement navigieren',
  'feature.utilityInfo': 'Funktions-Utility-Informationen',
  'feature.utility.cardTitle': 'Utility-Zähler-Informationen',
  'feature.utility.helper':
    'Konfigurieren Sie Utility-Grenzwerte und Verbrauchszeiträume',
  'feature.utility.enabled': 'Utility-Grenzwerte aktivieren?',
  'feature.utility.counter': 'Utility-Zähler',
  'feature.utility.duration': 'Utility-Dauer',
  'feature.usage': 'Usage',
  'feature.save.confirm.title': 'Speicheroptionen',
  'feature.save.confirm.description':
    'Als neu speichern oder bestehendes aktualisieren',
  'feature.assigned.subscriptions': 'Zugewiesene Abonnements ({{count}})',
  'feature.subscriptions.helper':
    'Um Abonnements zuzuweisen, können Sie aus der Liste der aktiven Abonnements auswählen.',
  'feature.msg.unAssignConfirm':
    'Sind Sie sicher, dass Sie dieses Abonnement aufheben möchten?',
};
